import React from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { Job } from '@libs/graphql-types';

const useStyles = makeStyles((theme: any) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(6),
  },
  metricsContainer: {
    backgroundColor: '#fff',
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
  },
  title: {
    fontSize: '1rem',
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(2),
  },
  topRow: {
    marginBottom: theme.spacing(3),
  },
  metricColumn: {},
  label: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginRight: theme.spacing(2),
  },
  value: {
    fontWeight: 500,
    fontSize: '0.875rem',
    color: theme.palette.info.main,
  },
}));

interface PerformanceMetricsProps {
  jobData: Job;
}

export const PerformanceMetrics: React.FC<PerformanceMetricsProps> = ({
  jobData,
}) => {
  const classes = useStyles();

  // These fields are not in the schema, so we use '-' as placeholder
  // You can map actual fields if/when available
  const getValue = (val: any) =>
    val !== undefined && val !== null && val !== '' ? val : '-';

  // Example: If you have these fields in jobData or jobData.striive_job, map them here
  // Otherwise, use '-'
  // const striive = jobData.striive_job || {};

  // Use actual Job schema fields for performance metrics
  const totalApplications = getValue(jobData.matches_with_application_count);
  const totalSubmittals = getValue(jobData.matches_count);
  const totalShortlisted = getValue(jobData.instant_matches_count);
  const totalOffers = '-';
  const totalOffersDeprecated = '-';

  return (
    <Box className={classes.root}>
      <Box className={classes.metricsContainer}>
        <Typography className={classes.title}>Performance</Typography>

        <Grid container className={classes.topRow} spacing={2}>
          <Grid item xs={12} sm={4}>
            <Box className={classes.metricColumn}>
              <Typography className={classes.label} component="span">
                Total Applications
              </Typography>
              <Typography className={classes.value} component="span">
                {totalApplications}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box className={classes.metricColumn}>
              <Typography className={classes.label} component="span">
                Total Submittals
              </Typography>
              <Typography className={classes.value} component="span">
                {totalSubmittals}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box className={classes.metricColumn}>
              <Typography className={classes.label} component="span">
                Total shortlisted
              </Typography>
              <Typography className={classes.value} component="span">
                {totalShortlisted}
              </Typography>
            </Box>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Box className={classes.metricColumn}>
              <Typography className={classes.label} component="span">
                Total Offers
              </Typography>
              <Typography className={classes.value} component="span">
                {totalOffers}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box className={classes.metricColumn}>
              <Typography className={classes.label} component="span">
                Total Offers (Deprecated)
              </Typography>
              <Typography className={classes.value} component="span">
                {totalOffersDeprecated}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};
